import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import DragDrop from "./drag-drop/DragDrop"
import PlanillaCard from "./PlanillaCard"
import ModalLoadFile from "./ModalLoadFile"
import Usuarios from "./Usuarios.jsx"

const Preferencias = ({ user }) => {
  const [files, setFiles] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const planillas = [
    {
      id: "sadasdasd132123",
      name: "Planilla 1"
    },
    {
      id: "sadasdasd13212223",
      name: "Planilla 2"
    },
    {
      id: "sadasdasd132122231",
      name: "Planilla 2"
    },
    {
      id: "sadasdasd132122232",
      name: "Planilla 2"
    },
    {
      id: "sadasdasd132122233",
      name: "Planilla 2"
    },
    {
      id: "sadasdasd132122234",
      name: "Planilla 2"
    },
    {
      id: "sadasdasd132122235",
      name: "Planilla 2"
    }

  ]
  const [loading, setLoading] = useState(false);
  const [preferencias, setPrefenrencias] = useState(true);
  const onClose = () => {
    setOpenModal(false)
  }
  const handleFormClick2 = (e) => {
    e.stopPropagation(); // Evita que el evento de clic se propague hacia arriba
  };
  return (

    <ContainerBox >
               {
          openModal ?
            <ModalLoadFile
            onClose={onClose}
            stopPropagation={handleFormClick2}
            files={files}
            setFiles={setFiles}
            setOpenModal={setOpenModal}
            setPrefenrencias={setPrefenrencias}
            />
            : null
        }
      {/* <Text2>Preferencias</Text2> */}
      {/* <UploadForm/> */}


      <DivRow>
        <Text3
          style={{
            fontSize: "25px",
            fontWeight: "bold"
          }}
        >
          Listas de contactos
        </Text3>
        <DivColumPlanillas
        style={{
          marginRight: "84px"
        }}
        >
          <Text3
          style={{
            fontSize: "12px",
            fontWeight: 600,
            lineHeight:"18px",
            letterSpacing:"2%"
          
          }}
          >
            NUEVA LISTA
          </Text3>
          <DragDrop
            files={files}
            setFiles={setFiles}
            setLoading={setLoading}
            preferencias={preferencias}
            setPrefenrencias={setPrefenrencias}
            setOpenModal={setOpenModal}
          />
        </DivColumPlanillas>

        <DivColumPlanillas
        style={{
          width: "47%"
        }}
        >
          <Text3 
            style={{
              fontSize: "12px",
              fontWeight: 600,
              lineHeight:"18px",
              letterSpacing:"2%"
            }}
          >
          LISTAS EXISTENTES
          </Text3>

          <ScrollContainer >


            {planillas.length > 0 ?
              planillas.map((data, index) => (
                <PlanillaCard
                  key={data.id + index}
                  planilla={data}


                />
              ))
              : null

            }

          </ScrollContainer>
        </DivColumPlanillas>
      </DivRow>

      <Usuarios/>

    </ContainerBox>

  );
};

const DivColumPlanillas = styled.div`
width: calc(45% - 50px);
// max-width: calc(45% - 50px);
display:flex;
flex-direction: column;
gap:1px;
flex-grow: 1;
margin-top:8px;
`;
const DivRow = styled.div`
width: 80%;
padding: 46px;
display: flex;
flex-wrap: wrap;
align-items: flex-start;
justify-content: flex-start;
  box-shadow: 0px 1.5px 2px 0px rgba(16, 24, 40, 0.10);
  border: 1px solid var(--Neutral-Gray-Gray-100, #E0E2E7);
border-radius: 8px;
flex-direction: row;
`;
const Text3 = styled.span`
width: -webkit-fill-available;
font-family: 'Montserrat', sans-serif;
color: #003049;
`;
const ContainerBox = styled.div`
width: -webkit-fill-available;
height: auto;
min-height: 95vh;
max-height: 95vh;
overflow-y: auto;
max-width: calc(100vw - 84px);
gap: 36px;
display: flex;
flex-direction: column;
align-items: flex-start;
margin: 1% 1% 1% 1%;
padding: 1% 2% 84px 1%;
background-color: #FFFFFF;
border-radius: 8px;
justify-content: flex-start;
box-sizing: border-box;
    box-shadow: 0px 1.5px 2px 0px rgba(16, 24, 40, 0.10);
    border: 1px solid var(--Neutral-Gray-Gray-100, #E0E2E7);
&::-webkit-scrollbar {
  height: 4px;
  width: 3px;
  background-color: transparent !important;
}

&::-webkit-scrollbar-track {
  background: transparent;
}

&::-webkit-scrollbar-thumb {
  background-color: #003049 !important;
  border-radius: 8px;
}
@media only screen and (min-width:0px) and (max-width:1100px){
  margin: 5vh 0px 0px 0px;
  max-width: calc(100vw - 0px);
}
`;
const ScrollContainer = styled.div`
width: -webkit-fill-available;
height: auto;
max-height: 250px;
overflow-y: auto;
overflow-x: hidden;
gap: 0px;
display: flex;
flex-direction: column;
align-items: center;
margin: 0%;
scroll-behavior: smooth;
padding: 8px 0px 0px 0px;
// border-top: 2px solid #003049;
justify-content: flex-start;

  &::-webkit-scrollbar {
    height: 4px;
    width: 3px;
    background-color: transparent !important;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #003049 !important;
    border-radius: 8px;
  }

`;


export default Preferencias;